import { render, staticRenderFns } from "./UnitsTable.vue?vue&type=template&id=3b06e199"
import script from "./UnitsTable.vue?vue&type=script&lang=js"
export * from "./UnitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports